import { createFileRoute } from '@tanstack/react-router'
import { FormWorkerRole } from 'siteline-common-web'
import { z } from 'zod'
import { looseString } from '../common/util/SearchParams'
import { FormTemplateTurnaroundDashboard } from '../components/form-template-turnaround/FormTemplateTurnaroundDashboard'

export const Route = createFileRoute('/_a/formTurnaround')({
  component: FormTemplateTurnaroundDashboard,
  validateSearch: z.object({
    teamMemberId: looseString.optional(),
    role: z.union([z.enum(FormWorkerRole), z.literal('Any')]).optional(),
    requestingCompanyId: looseString.optional(),
  }),
})
